import { createContext } from 'react';

import type { AnalyticsHook } from './useInternalAnalytics.ts';

export const AnalyticsContext = createContext<undefined | AnalyticsHook>(undefined);
